import { render, staticRenderFns } from "./afterSaleManagement.vue?vue&type=template&id=fd0890b2&scoped=true&"
import script from "./afterSaleManagement.vue?vue&type=script&lang=js&"
export * from "./afterSaleManagement.vue?vue&type=script&lang=js&"
import style0 from "./afterSaleManagement.vue?vue&type=style&index=0&id=fd0890b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0890b2",
  null
  
)

export default component.exports